import { t } from "i18next";

import React from "react";

import { FireIcon } from "@components/OrderTaking/Components/Icons/FireIcon";

import "./index.css";

type KcalBadgeProps = {
    kcal: number | null | undefined;
    size?: "sm" | "md";
    compact?: boolean;
    iconSrc?: string;
};

type Tier = "green" | "amber" | "orange";

function getTier(kcal: number): Tier {
    if (kcal < 100) return "green";
    if (kcal <= 800) return "amber";
    return "orange";
}

const TIER_COLOR: Record<Tier, string> = {
    green: "var(--kcal-green)",
    amber: "var(--kcal-amber)",
    orange: "var(--kcal-flame)",
};

export function KcalBadge({
    kcal,
    size = "sm",
    compact = false,
    iconSrc,
}: KcalBadgeProps): JSX.Element | null {
    if (kcal === null || kcal === undefined) return null;
    const value = Number(kcal);
    if (!Number.isFinite(value) || value <= 0) return null;

    const tier = getTier(value);
    const label = `${Math.round(value)} ${t("kcal")}`;

    return (
        <span
            aria-label={label}
            className="kcal-badge"
            data-size={size}
            data-compact={compact ? "true" : undefined}
            data-tier={tier}
        >
            <span aria-hidden className="kcal-badge__icon">
                {iconSrc ? (
                    <img src={iconSrc} alt="" />
                ) : (
                    <FireIcon
                        color={TIER_COLOR[tier]}
                        width="100%"
                        height="100%"
                    />
                )}
            </span>
            {label}
        </span>
    );
}
